/* eslint-disable import/extensions */
import countries from '../consts/countries.mjs'

const getCountryFromHost = (host = '') => {
  const hostname = host || window.location.hostname
  const hostArray = hostname.split('.')
  const countryFromHost = countries[hostArray[hostArray.length - 1]]

  return countryFromHost
}

export default getCountryFromHost
